<template>
  <div class="container">
    <div class="navbar-left">
      <button class="navbar-toggler" type="button">&#9776;</button>
      <img height="100px" :src="logoImage" />
    </div>

    <section class="navbar-mobile">
      <span class="navbar-divider d-mobile-none"></span>

      <ul class="nav nav-navbar">
        <li class="nav-item">
          <a class="nav-link" href="/">Home</a>
        </li>
        <li class="nav-item">
          <a href="/about" class="nav-link">About Us</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Services <span class="arrow"></span></a>
          <ul class="nav">
            <li class="nav-item">
              <a class="nav-link" href="/web-app">Web & Mobile App</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="/hosting">Cloud Services</a>
            </li>
          </ul>
        </li>

        <li class="nav-item">
          <a href="/contact" class="nav-link">Contact Us</a>
        </li>
      </ul>
    </section>

    <!-- <a class="btn btn-xs btn-round btn-success" href="https://themeforest.net/item/thesaas-responsive-bootstrap-saas-software-webapp-template/19778599?license=regular&open_purchase_for_item_id=19778599&purchasable=source&ref=thethemeio">Buy Now</a> -->
  </div>
</template>
<script>
// import logoImage from '../../public/Favicon.png';
import logoImage from "../assets/img/logo/300px.png";

export default {
  data: () => ({
    logoImage,
  }),
};
</script>
